import {
  FETCH_DAILY_RECORDS,
  FETCH_DAILY_RECORDS_SUCCESS,
  FETCH_DAILY_RECORDS_FAILURE,
} from "./constants";

export const fetchDailyRecords = (payload) => ({
  type: FETCH_DAILY_RECORDS,
  payload,
});
export const fetchDailyRecordsSuccess = (payload) => ({
  type: FETCH_DAILY_RECORDS_SUCCESS,
  payload,
});
export const fetchDailyRecordsFailure = () => ({
  type: FETCH_DAILY_RECORDS_FAILURE,
});
